// extracted by mini-css-extract-plugin
module.exports = {"container":"NftGrid_container__2v7A0","noResults":"NftGrid_noResults__34PNP"};